import { createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const initialState = {
  isLoading: false,
  exams: [],
  exam: null,
  currentExam: null,
  error: null,
  isEditingExam: false,
  isDeletingExam: false,
  isCreatingExam: false,
  isLoadingExam: true,
};

export const examSlice = createSlice({
  name: "exam",
  initialState,
  reducers: {
    setCurrentExam: (state, action) => {
      state.currentExam = action.payload;
    },
    getExamStart: (state, action) => {
      state.isLoadingExam = true;
      state.error = null;
    },
    getExamSuccess: (state, action) => {
      state.isLoadingExam = false;
      state.exam = action.payload;
      state.error = null;
    },
    getExamFailure: (state, action) => {
      state.isLoadingExam = false;
      state.error = action.payload;
    },
    resetExamLoading: (state, action) => {
      state.isLoadingExam = true;
    },
    createExamStart: (state, action) => {
      state.isCreatingExam = true;
      state.error = null;
    },
    createExamSuccess: (state, action) => {
      state.isCreatingExam = false;
      state.error = null;
    },
    createExamFailure: (state, action) => {
      state.isCreatingExam = false;
      state.error = action.payload;
    },
    getAllExamsStart: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    getAllExamsSuccess: (state, action) => {
      state.isLoading = false;
      state.exams = action.payload;
      state.error = null;
    },
    getAllExamsFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    editExamStart: (state, action) => {
      state.isEditingExam = true;
    },
    editExamSuccess: (state, action) => {
      state.isEditingExam = false;
    },
    editExamFailure: (state, action) => {
      state.isEditingExam = false;
      state.error = action.payload;
    },
    deleteExamStart: (state, action) => {
      state.isDeletingExam = true;
    },
    deleteExamSuccess: (state, action) => {
      state.isDeletingExam = false;
    },
    deleteExamFailure: (state, action) => {
      state.isDeletingExam = false;
      state.error = action.payload;
    },
  },
});

export const {
  getExamStart,
  getExamSuccess,
  getExamFailure,
  resetExamLoading,
  createExamStart,
  createExamSuccess,
  createExamFailure,
  getAllExamsStart,
  getAllExamsSuccess,
  getAllExamsFailure,
  editExamStart,
  editExamSuccess,
  editExamFailure,
  deleteExamStart,
  deleteExamSuccess,
  deleteExamFailure,
  setCurrentExam,
} = examSlice.actions;

const persistConfig = {
  key: "examGroup",
  storage,
  whitelist: ["currentExamGroup"],
};

const examReducer = examSlice.reducer;
export default persistReducer(persistConfig, examReducer);
